import { RAD } from './constants.js';

/** The same rectilinear projection as applyFpv, expressed in recorded pixels.
 * No browser viewport size or device pixel ratio enters this calculation. */
export function projectRecordedPoint(cam, g, p) {
  const dx = p.x - cam.x, dy = p.y - cam.y, dz = p.height - cam.h;
  const pan = cam.pan * RAD, tilt = cam.tilt * RAD;
  const forward = dx * Math.cos(pan) + dy * Math.sin(pan);
  const depth = forward * Math.cos(tilt) - dz * Math.sin(tilt);
  if (depth <= 0.05 || g.m.pano) return null;
  const right = dy * Math.cos(pan) - dx * Math.sin(pan), up = forward * Math.sin(tilt) + dz * Math.cos(tilt);
  return { x: g.m.resW * (0.5 + right / (2 * depth * Math.tan(g.hfov * RAD / 2))),
    y: g.m.resH * (0.5 - up / (2 * depth * Math.tan(g.vfov * RAD / 2))), depth };
}

/** Maximum image displacement during a centred, constant-velocity exposure.
 * Includes perspective expansion. Does not model rolling shutter or ISP blur. */
export function recordedMotion(cam, g, points, speed, heading, exposureMs) {
  if (!(speed > 0)) return 0;
  if (!(exposureMs > 0) || !g || g.m.pano) return null;
  const distance = speed * exposureMs / 1000, angle = heading * RAD;
  const dx = Math.cos(angle) * distance / 2, dy = Math.sin(angle) * distance / 2;
  const shifts = points.map(p => {
    const a = projectRecordedPoint(cam, g, { ...p, x: p.x - dx, y: p.y - dy });
    const b = projectRecordedPoint(cam, g, { ...p, x: p.x + dx, y: p.y + dy });
    return a && b ? Math.hypot(b.x - a.x, b.y - a.y) : null;
  });
  return shifts.length && shifts.every(v => v != null) ? Math.max(...shifts) : null;
}
